import React from "react";
import styled from "styled-components";
import { GetInfo } from "@xfrontend/xicon";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  height: 100%;
  position: relative;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
`;

const BigStat = styled.div<{ $valueColor: string; $labelColor: string }>`
  .value {
    font-size: 30px;
    font-weight: bold;
    color: #f6f6f7;
  }
  .label {
    font-size: 12px;
    color: #cfd0d3;
  }
`;

interface InfoStatProps {
  value: number | string;
  label: string;
}

const InfoStat: React.FC<InfoStatProps> = ({ value, label }) => (
  <Container>
    <IconWrapper>
      <GetInfo size={14} color="var(--x-gray-200)" />
    </IconWrapper>
    <BigStat>
      <div className="value">{value}</div>
      <div className="label">{label}</div>
    </BigStat>
  </Container>
);

export default InfoStat;
